// Owner's blueprint detail page (requirements 4.4, 11.15); with blueprint sets enabled, the sets that use the
// blueprint and their Document_Type conflicts (blueprint-sets Req 1.7, 2.7).
import { useNavigate, useParams } from 'react-router';
import Alert from '@cloudscape-design/components/alert';
import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Spinner from '@cloudscape-design/components/spinner';
import { useBlueprint } from '../../api/hooks';
import { hasRole, useAuth } from '../../auth/AuthProvider';
import { BlueprintView } from './BlueprintView';
import { setsEnabled } from '../../config';
import { errorMessage } from '../../lib/notify';

export function BlueprintDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const q = useBlueprint(id);
  if (q.error) return <Alert type="error">{errorMessage(q.error)}</Alert>;
  if (!q.data) return <Spinner size="large" />;
  const latest = q.data.blueprint.latestVersion;
  return (
    <BlueprintView
      detail={q.data}
      showNotices
      showSets={setsEnabled() && hasRole(user, 'BlueprintAuthor')}
      actions={
        <SpaceBetween direction="horizontal" size="xs">
          <Button onClick={() => navigate(`/run?blueprintId=${id}`)}>Run a document</Button>
          <Button disabled={!latest} onClick={() => navigate(`/packages/new?blueprintId=${id}&version=${latest}`)}>
            Create handoff package
          </Button>
          <Button variant="primary" onClick={() => navigate(`/blueprints/${id}/edit`)}>
            Edit
          </Button>
        </SpaceBetween>
      }
    />
  );
}
